module.exports = __webpack_public_path__ + "assets/images/cbba427d645adb932a6ddd7854efa524.svg";